/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCategory } from '../models/work-category';

@Injectable({ providedIn: 'root' })
export class WorkCategoriesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `categoriesV1ControllerFindAll()` */
  static readonly CategoriesV1ControllerFindAllPath = '/v1/categories';

  /**
   * Required permissions: contacts:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoriesV1ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoriesV1ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCategory>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCategoriesService.CategoriesV1ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCategory>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoriesV1ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoriesV1ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkCategory>> {
    return this.categoriesV1ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCategory>>): Array<WorkCategory> => r.body)
    );
  }

}
